import React from 'react';
import PropTypes from 'prop-types';
import RegressionPieStatsContainer
  from './../Containers/RegressionPieStatsContainer';
import CaseAmendingPieStatsContainer
  from './../Containers/CaseAmendingPieStatsContainer';
import DispatcherInfoContainer from '../Containers/DispatcherInfoContainer';
import RadioButtonContainer
  from './../Containers/RadioButtonContainer';
import ScenarioListContainer
  from './../Containers/ScenarioListContainer';
import RegressionFailureTrendsContainer
  from './../Containers/RegressionFailureTrendsContainer';
import RegressionBarStatsContainer
  from './../Containers/RegressionBarStatsContainer';
import {
  dispatcherTypes as constants,
  commonPageInfo as commonPageHelpers
} from './../helpers';
import { Route } from 'react-router-dom';

import {
  Col,
  Row,
  PanelGroup,
  FormGroup,
  FormControl,
  Tab,
  Tabs,
} from 'react-bootstrap';

export default class RegressionViewComponent extends React.Component {
  static propTypes = {
    concerningTrendingOnly: PropTypes.bool,
    currentDispatcherTestsOnly: PropTypes.bool,
    dispatcherType: PropTypes.string.isRequired,
    installerPage: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onClickTab: PropTypes.func.isRequired,
    reducedHeaders: PropTypes.array.isRequired,
    scenarios: PropTypes.array.isRequired,
    scenariosOfSelectedDispatcher: PropTypes.array,
    setConcerningTrendingOnly: PropTypes.func.isRequired,
    setCurrentDispatcherTestsOnly: PropTypes.func.isRequired,
    tabInURL: PropTypes.string.isRequired,
    trendingHeaders: PropTypes.array.isRequired,
  };

  render() {
    const {
      concerningTrendingOnly,
      currentDispatcherTestsOnly,
      dispatcherType,
      installerPage,
      onChange,
      onClickTab,
      reducedHeaders,
      scenarios,
      scenariosOfSelectedDispatcher,
      setConcerningTrendingOnly,
      setCurrentDispatcherTestsOnly,
      tabInURL,
      trendingHeaders,
    } = this.props;
    return (
      <Tabs
        defaultActiveKey={tabInURL ? tabInURL : commonPageHelpers.DISPATCHER_INFO}
        id="regression-tabs"
        onSelect={onClickTab.bind(this)}
      >
        <Tab eventKey={commonPageHelpers.DISPATCHER_INFO} title="Dispatcher Info">
          <Route path="/:dispatcher"
            render={() => <div>
              <Row>
                <Col md={12} style={{ padding: 0 }}>
                  <DispatcherInfoContainer />
                </Col>
                <Col md={12}>
                  {scenarios.length > 0 && <RadioButtonContainer />}
                </Col>
              </Row>
              <Row>
                <PanelGroup id="regression-view-component">
                  <Row className="padded">
                    <Col md={12}>
                      {dispatcherType === constants.CASEAMENDINGTESTS ?
                        <CaseAmendingPieStatsContainer
                          scenarios={scenariosOfSelectedDispatcher}
                          chartWidth={4}
                        /> :
                        <RegressionPieStatsContainer
                          scenarios={scenariosOfSelectedDispatcher}
                          chartWidth={4}
                        />
                      }
                    </Col>
                  </Row>
                  <Row className="padded">
                    {scenarios !== undefined && scenarios.length > 0 ?
                      (<Col md={3} mdOffset={9}>
                        <FormGroup>
                          <FormControl type="text" placeholder="Search"
                            onChange={evt => onChange(evt.target.value)}
                          />
                        </FormGroup>
                      </Col>) : null
                    }
                    <Col md={12}>
                      <ScenarioListContainer
                        columns={reducedHeaders}
                        trendingColumns={trendingHeaders}
                        installerPage={installerPage}
                        concerningTrendingOnly={concerningTrendingOnly}
                        setConcerningTrendingOnly={setConcerningTrendingOnly}
                        currentDispatcherTestsOnly={currentDispatcherTestsOnly}
                        setCurrentDispatcherTestsOnly={setCurrentDispatcherTestsOnly}
                      />
                    </Col>
                  </Row>
                </PanelGroup>
              </Row>
            </div>}
          />
        </Tab>
        <Tab eventKey={commonPageHelpers.FAILURE_TRENDS} title="Failure Trends">
          <Route path="/:dispatcher"
            render={() => <div>
              <RegressionBarStatsContainer />
              <RegressionFailureTrendsContainer />
            </div>}
          />
        </Tab>
      </Tabs>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/RegressionViewComponent.jsx